import { Component } from '@angular/core';
import { BingMapsLoader } from '@services/map-loader.service';

@Component({
  selector: 'app-geo-portal-baladeya',
  templateUrl: './geo-portal-baladeya.component.html',
  styleUrl: './geo-portal-baladeya.component.scss'
})
export class GeoPortalBaladeyaComponent {
  mapReady = false;
  constructor() {
  BingMapsLoader.load()
  .then(res => {
      console.log('BingMapsLoader.load.then', res);
      this.mapReady = true;
    });
  }
  
}
